<div class="tt-anchor-links-popover-guideline_header">
  <button class="back-button" (click)="clearSelectedGuideline.emit()">
    <common-chip size="icon" [clickable]="true" [variant]="'transparent'">
      <mat-icon [icon]="'chevron-left'" [iconSize]="14" />
    </common-chip>
  </button>

  <label class="tt-anchor-links-popover-guideline_search__label" for="tt-anchor-links-popover-guideline_link"
    >{{ 'SearchIn' | transloco }} <span>{{ guideline.title }}</span></label
  >
</div>

<tt-form-field>
  <input
    class="tt-anchor-links-popover-guideline_link"
    id="tt-anchor-links-popover-guideline_link"
    ttInput
    type="text"
    [placeholder]="'SearchPlaceholder' | transloco"
    [(ngModel)]="searchTerm"
    (ngModelChange)="handleSearchChanged($event)" />
  @if (showHint()) {
    <tt-hint>{{ 'StartTypingForResults' | transloco }}</tt-hint>
  }
</tt-form-field>

<div class="tt-anchor-links-popover-guideline_results">
  @if (results().length === 0 && !showHint() && searchTerm().length !== 0) {
    <div class="tt-anchor-links-popover-guideline_no-results">
      <mat-icon class="tt-anchor-links-popover_no-results-icon" [icon]="'search-x'" [iconSize]="24" />
      {{ 'NoResultsFoundInSearch' | transloco }}
    </div>
  } @else {
    @for (link of results(); track link) {
      <div class="tt-anchor-links-popover-guideline_result" (click)="linkSelected.emit(link)">
        @if (link.toElementType === LinkElementType.Chapter) {
          <mat-icon
            class="tt-anchor-links-popover-guideline_result__icon"
            [icon]="'bookmark'"
            [iconSize]="20"
            [ttTooltip]="'Chapter' | transloco" />
        }
        @if (link.toElementType === LinkElementType.Component) {
          <mat-icon
            class="tt-anchor-links-popover-guideline_result__icon"
            [icon]="'component'"
            [iconSize]="20"
            [ttTooltip]="'Component' | transloco" />
        }
        @if (link.toElementType === LinkElementType.FlowchartNode) {
          <mat-icon
            class="tt-anchor-links-popover-guideline_result__icon"
            [icon]="'git-fork'"
            [iconSize]="20"
            [ttTooltip]="'FlowchartElement' | transloco" />
        }
        <div
          class="tt-anchor-links-popover-guideline_result__container"
          [attr.data-testid]="'anchor-link_search-result_' + link.title.split(' ').join('-')">
          <p class="tt-anchor-links-popover-guideline_result__title">{{ link.title }}</p>
          <p class="tt-anchor-links-popover-guideline_result__path">{{ link.path }}</p>
        </div>
      </div>
    }
  }
</div>
